<template>
  <div class="component-playback" id="playbackContent">
    <div class="playback-content" :style="{'width': props.data === 2025 ? '1400px' : '100%'}">
      <div style="flex: 1; margin-right: 24px;">
        <play-show :data="currentData" type="pc" v-if="showVideo"></play-show>
        <div class="playback-none" v-else></div>
      </div>
      <div style="height: 550px; width: 500px">
        <play-tablist type="pc" :data="props.data" @playVideo="playVideo"></play-tablist>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, ref, onMounted, watch } from 'vue'
import PlayShow from './play-show.vue'
import PlayTablist from './play-tablist.vue'

const props = defineProps({
  data: {
    type: Number,
    default: 2025
  }
})

let showVideo = ref(false)

const currentData = ref({})
const playVideo = (data) => {
  currentData.value = data
  showVideo.value = false
  nextTick(() => {
    showVideo.value = true
  })
}

onMounted(() => {
})


</script>

<style lang="scss" scoped>
.component-playback {
  width: 100%;
  margin-top: -198px;
  display: flex;
  justify-content: center;
  .playback-content {
    display: flex;
    justify-content: space-between;
    .playback-none{
        width: 100%;
        height: 100%;
        background: #ffffff;
        border-radius: 24px;
    }
  }
}
</style>
